/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const file_csv = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.29 4.5 8.62 1.353A1 1 0 0 0 7.857 1H2a1 1 0 0 0-1 1v11.843a1 1 0 0 0 1 1h2"
    />
    <path
      fill="#000"
      d="M5.041 10.334c0-.927.32-1.534.82-1.534.427 0 .653.254.72.807l.927-.327c-.14-.853-.727-1.346-1.6-1.346-1.174 0-1.887.906-1.887 2.4 0 1.52.693 2.4 1.887 2.4.82 0 1.34-.374 1.62-1.167l-.834-.46c-.166.58-.36.76-.82.76-.533 0-.833-.553-.833-1.533Zm4.858 2.4c1.026 0 1.673-.554 1.673-1.434 0-.693-.427-1.153-1.3-1.386l-.447-.12c-.4-.107-.553-.254-.553-.534 0-.3.26-.5.653-.5.34 0 .614.22.68.56l.854-.4c-.12-.586-.747-.986-1.547-.986-.96 0-1.64.58-1.64 1.386 0 .7.407 1.147 1.247 1.374l.446.12c.447.12.607.28.607.58 0 .32-.253.513-.673.513-.427 0-.654-.193-.88-.767l-.834.487c.247.74.82 1.107 1.714 1.107ZM14.89 8l-.867 3.434L13.149 8h-1.046l1.426 4.667h.947L15.903 8h-1.014Z"
    />
  </svg>
)
export default file_csv
